import React from 'react'
import { motion } from 'framer-motion';
import ResumeCard from './ResumeCard';

const Education = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      {/* part one */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-6">
          {/* <p className="text-sm text-designColor tracking-[4px]">2018- 2022</p> */}
          <h2 className="text-3xl md:text-4xl font-bold">Education </h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
        <ResumeCard
            title="Kanpur University"
            subTitle="Bachelor of Commerce (B.Com)"
            des="Completed Bachelor's degree in Commerce with a focus on accounting, finance, business law, and economics. Developed strong analytical, financial, and managerial skills through coursework and academic projects."
          />
        <ResumeCard
  title="Surya Institute"
  subTitle="Industrial Training Institute (ITI)"
  des="Completed Basic Skill Set training focused on foundational technical and vocational skills across multiple domains. Gained essential knowledge in safety protocols, basic machinery handling, tool usage, and introductory workshop practices. This training provided a strong groundwork for further specialization and industry readiness."
/>


          {/* <ResumeCard
            title="Secondary School Education"
            subTitle="K.G.G.I.C (2015 - 2017)"
            result="70%"
            des="Secondary education or post-primary education covers two phases on the International Standard Classification of Education scale."
          /> */}
        </div>
      </div>
      {/* part Two */}

      {/* <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-6">
          <p className="text-sm text-designColor tracking-[4px]">2018 - 2024</p>
          <h2 className="text-3xl md:text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Motion Graphic Artist"
            // subTitle="Unicosmosoft pvt. Ltd - (2023 - Present)"
            result="Lucknow "
            des="Creative and dedicated motion graphic artist with one year of experience in developing dynamic animations and video content.
Proficient in Adobe After Effects and Premiere Pro, with a strong foundation in graphic design principles.
Seeking an opportunity to contribute to a forward-thinking media team."
          />
          <ResumeCard
            title="Graphic Designer"
            // subTitle="Cetpa Infotech pvt. ltd - (2022 - 2023)"
            result="Lucknow"
            des="Creative graphic designer with four years of experience in print and digital design.
Proficient in Adobe Creative Suite, specializing in branding, marketing materials, and political graphic.
Strong collaborative skills with a keen eye for detail and a passion for innovative design solutions."
          />
        </div>

      </div> */}
    </motion.div>
  );
}

export default Education